import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import {
  createEntity as createCandidate,
  getCandidateWithCode,
  reset as resetCandidate,
} from "../../../reducers/candidateReducer";
import { reset as resetCode, createCode } from "../../../reducers/codeReducer";

import { Button, Modal } from "react-bootstrap";
import OTPInput, { ResendOTP } from "otp-input-react";
import { Col, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faExclamation } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import { IRootState } from "../../../reducers";
import { BodyCodeValidation } from "../../../shared/dialog/body-modal/modal-code-validate";
import { BodyLoading } from "../../../shared/dialog/body-modal/modal-loading";

export interface IProps extends StateProps, DispatchProps {
  setShowModal: (data: boolean) => void;
  showDocExists: boolean;
  setShowDocExists: (data: boolean) => void;
  showCode: boolean;
  setShowCode: (data: boolean) => void;
  showSaved: boolean;
  setShowSaved: (data: boolean) => void;
  showAlreadyApplied: boolean;
  setShowAlreadyApplied: (data: boolean) => void;
  handleClose: () => void;
}
const renderButton = (buttonProps: any) => {
  return (
    <button {...buttonProps}>
      {buttonProps.remainingTime !== 0
        ? `Por favor espere ${buttonProps.remainingTime} segundos`
        : "Reenviar código"}
    </button>
  );
};
const renderTime = () => React.Fragment;

export const ModalDocumentProcess = (props: IProps) => {
  const history = useHistory();
  const {
    showDocExists,
    showCode,
    showSaved,
    showAlreadyApplied,
    validation,
    loading,
    loadingCode,
  } = props;

  const [OTP, setOTP] = useState("");

  const submitCode = () => {
    // loading...
    props.getCandidateWithCode(validation.candidate_id, OTP);
  };

  const resetEntities = () => {
    props.resetCandidate();
    props.resetCode();
  };

  const resendCode = () => {
    if (validation.mail?.length && validation.is_candidate) {
      props.createCode({ candidate_id: validation.candidate_id });
    }
  };

  // sends code to get the Candidate
  useEffect(() => {
    if (OTP.length === 5) {
      submitCode();
    }
  }, [OTP]);

  useEffect(() => {
    if (!loading) {
      if (OTP.length === 5) {
        setOTP("");
        props.setShowCode(false);
        props.setShowModal(false);
      }
    }
  }, [loading]);

  const closeModal = () => {
    props.setShowModal(false);
    props.setShowDocExists(false);
    resetEntities();
  };

  return (
    <>
      <Modal show={true} backdrop="static" centered className={"modal-generic"}>
        {loading || (loadingCode && <BodyLoading />)}

        {showDocExists && (
          <>
            <BodyCodeValidation
              validation={props.validation}
              handleClose={props.handleClose}
            />
            <Modal.Footer>
              <Button
                className="cancel-modal"
                onClick={() => {
                  props.setShowModal(false);
                  props.setShowDocExists(false);
                  resetEntities();
                  history.push("/1/problem");
                }}
              >
                Tengo un problema
              </Button>
              <Button
                className="save-modal"
                onClick={() => {
                  props.setShowCode(true);
                  props.setShowDocExists(false);
                }}
              >
                Ingresar código
              </Button>
            </Modal.Footer>
          </>
        )}

        {showCode && (
          <>
            <Modal.Header className="header-modal-already-postulate fw-bold fs-5 text-dark">
              Escriba el código a continuación
            </Modal.Header>

            <Modal.Body className="modal-body-generic modal-body-already-postulate text-center">
              <OTPInput
                value={OTP}
                onChange={setOTP}
                autoFocus
                OTPLength={5}
                otpType="alphanumeric"
                disabled={false}
                className="otp-root"
                secure
              />
              <ResendOTP
                renderButton={renderButton}
                renderTime={renderTime}
                className="resend-button"
                onResendClick={resendCode}
              />
            </Modal.Body>

            <Modal.Footer>
              <Button
                className="cancel-modal"
                onClick={() => {
                  props.setShowCode(false);
                  props.setShowDocExists(true);
                }}
              >
                Volver
              </Button>
            </Modal.Footer>
          </>
        )}
        {showAlreadyApplied && (
          <>
            <Modal.Header className="header-modal-already-postulate fw-bold fs-5">
              ¡Ya estás postulado a esta búsqueda!
            </Modal.Header>

            <Modal.Body className="modal-body-generic modal-body-already-postulate text-center">
              <p>
                Nos pondremos en contacto en el caso de que continúes en el
                proceso.
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="cancel-error cancel-error-accept"
                onClick={() => {
                  props.setShowModal(false);
                  props.setShowCode(false);
                  resetEntities();
                  history.push("/?name=");
                }}
              >
                Aceptar
              </Button>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};
const mapStateToProps = (state: IRootState) => ({
  updating: state.candidateReducer.updating,
  updateSuccess: state.candidateReducer.updateSuccess,
  loading: state.candidateReducer.loading,
  validation: state.codeReducer.entity,
  loadingCode: state.codeReducer.loading,
  updatingCode: state.codeReducer.updating,
  updateSuccessCode: state.codeReducer.updateSuccess,
  candidate: state.candidateReducer.entity,
});

const mapDispatchToProps = {
  createCandidate,
  getCandidateWithCode,
  resetCandidate,
  resetCode,
  createCode,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalDocumentProcess);
